/**
 * GPT Image 2.0（gpt-image-2）manifest
 * 数据来源：image.json field_map
 * 特点：独占「图像质量」三档；比例含「智能比例」(auto)；清晰度 1K/2K/4K（独立）；参考图上限 16；支持 @ 参考图
 */
import type { ImageModelConfig } from '../../types';

export const gptImage2: ImageModelConfig = {
  id: '01KPWHD5J7909WW5VGH0D8CN4N',
  displayName: 'GPT Image 2.0',

  defaults: {
    ratio: '1:1', // 接口 select: true 项
    resolution: '2K', // 接口 resolution.default
    quality: 'medium', // 接口 quality.default
  },

  ratioOptions: {
    '*': [
      { label: '智能比例', value: 'auto' }, // 由模型按内容自动定比例
      { label: '1:1', value: '1:1' },
      { label: '2:3', value: '2:3' },
      { label: '3:2', value: '3:2' },
      { label: '3:4', value: '3:4' },
      { label: '4:3', value: '4:3' },
      { label: '9:16', value: '9:16' },
      { label: '16:9', value: '16:9' },
      { label: '21:9', value: '21:9' },
    ],
  },

  resolutionOptions: [
    { label: '1K', value: '1K' },
    { label: '2K', value: '2K' },
    { label: '4K', value: '4K' },
  ],
  resolutionLabel: '清晰度', // 接口 field_map.resolution.label

  qualityOptions: [
    { label: '低画质', value: 'low' },
    { label: '中画质', value: 'medium' },
    { label: '高画质', value: 'high' },
  ],

  // 支持 @ 参考图（GPT Image 系列）
  supportAtMention: true,

  toggles: {},

  limits: {
    maxRefImages: 16, // 接口 field_map.ref_images.max
  },
};
